<template>
  <section id="about" class="py-20 lg:py-32 bg-slate-950">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <!-- Text Content -->
        <div class="space-y-6 animate-fade-in-up">
          <h2 class="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-gold-gradient">
            عن شركة النضار
          </h2>
          <div class="w-20 h-1 bg-gold-gradient"></div>

          <p class="text-gray-300 text-lg leading-relaxed">
            شركة النضار لتجارة واستيراد الذهب والمجوهرات والسبائك الذهبية محدودة المسؤلية،
            الوجهة الأولى للعملاء المميزين الباحثين عن أرقى المجوهرات الذهبية. إرثنا مبني على الثقة والأصالة والالتزام
            الثابت بالتميز.
          </p>

          <p class="text-gray-300 text-lg leading-relaxed">
            يقع صالة العرض الخاصة بنا في المدينة القديمة، ويعرض مجموعة واسعة من المجوهرات الذهبية
            المصنوعة يدوياً، من التصاميم التقليدية إلى التحف المعاصرة. كل قطعة معتمدة للنقاء ومصنوعة
            من قبل حرفيين خبراء.
          </p>

          <div class="grid grid-cols-1 sm:grid-cols-3 gap-6 pt-6">
            <div class="text-center sm:text-left">
              <h3 class="text-3xl font-display font-bold text-gold-500 mb-2">10+</h3>
              <p class="text-gray-400">سنة من التميز</p>
            </div>
            <div class="text-center sm:text-left">
              <h3 class="text-3xl font-display font-bold text-gold-500 mb-2">5K+</h3>
              <p class="text-gray-400">عميل سعيد</p>
            </div>
          </div>
        </div>

        <!-- Image -->
        <div class="relative animate-fade-in-up" style="animation-delay: 0.2s;">
          <div class="relative overflow-hidden rounded-2xl shadow-2xl">
            <img src="https://images.unsplash.com/photo-1610375461246-83df859d849d?w=800&q=80"
              alt="Gold bars and jewelry"
              class="w-full h-[400px] lg:h-[600px] object-cover transform hover:scale-105 transition-smooth" />
            <!-- Overlay border effect -->
            <div class="absolute inset-0 border-2 border-gold-500/30 rounded-2xl pointer-events-none"></div>
          </div>

          <!-- Decorative element -->
          <div class="absolute -bottom-6 -right-6 w-32 h-32 bg-gold-gradient opacity-20 blur-3xl rounded-full"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
// No additional logic needed for this component
</script>
